export const Button = ({
  children,
  onClick,
  variant = "primary",
  className = "",
  disabled = false,
  type,
}) => {
  const variantStyles = {
    primary: "bg-flyers-orange hover:bg-flyers-orange-light text-white",
    secondary: "bg-flyers-charcoal hover:bg-flyers-dark-gray text-white border border-flyers-dark-gray hover:border-flyers-orange",
    danger: "bg-red-600 hover:bg-red-700 text-white",
  };

  const styles = `${variantStyles[variant]} font-heading font-bold uppercase tracking-wide py-2 px-4 rounded transition-all duration-150 ${className} ${
    disabled ? "opacity-50 cursor-not-allowed" : ""
  }`;

  return (
    <button onClick={onClick} className={styles} disabled={disabled} type={type}>
      {children}
    </button>
  );
};
